import { createAction } from 'redux-actions'
import {
  CREATE_USER_INBOX_FAILED,
  CREATE_USER_INBOX_SUCCEEDED,
  CREATE_USER_INBOX,
  GET_LOCAL_USER_FAILED,
  GET_LOCAL_USER_SUCCEEDED,
  GET_LOCAL_USER,
  GET_USER_PROFILE_FAILED,
  GET_USER_PROFILE_SUCCEEDED,
  GET_USER_PROFILE,
  REGISTER_USER_BY_OAUTH2_FAILED,
  REGISTER_USER_BY_OAUTH2_SUCCEEDED,
  REGISTER_USER_BY_OAUTH2,
  REGISTER_USER_FAILED,
  REGISTER_USER_SUCCEEDED,
  REGISTER_USER,
  RESEND_ACCOUNT_VERIFICATION_EMAIL_FAILED,
  RESEND_ACCOUNT_VERIFICATION_EMAIL_SUCCEEDED,
  RESEND_ACCOUNT_VERIFICATION_EMAIL,
  SHOW_REGISTRATION_ERROR,
  UPDATE_USER_FAILED,
  UPDATE_USER_SUCCEEDED,
  UPDATE_USER,
  VERIFY_ACCOUNT_EMAIL_FAILED,
  VERIFY_ACCOUNT_EMAIL_SUCCEEDED,
  VERIFY_ACCOUNT_EMAIL,
  CLEAR_REGISTER_USER_ERROR,
} from 'Redux/Types/UserTypes'

export const updateUser = createAction(UPDATE_USER)
export const updateUserFailed = createAction(UPDATE_USER_FAILED)
export const updateUserSucceeded = createAction(UPDATE_USER_SUCCEEDED)

export const registerUser = createAction(REGISTER_USER)
export const registerUserFailed = createAction(REGISTER_USER_FAILED)
export const registerUserSucceeded = createAction(REGISTER_USER_SUCCEEDED)

export const getLocalUser = createAction(GET_LOCAL_USER)
export const getLocalUserFailed = createAction(GET_LOCAL_USER_FAILED)
export const getLocalUserSucceeded = createAction(GET_LOCAL_USER_SUCCEEDED)

export const getUserProfile = createAction(GET_USER_PROFILE)
export const getUserProfileFailed = createAction(GET_USER_PROFILE_FAILED)
export const getUserProfileSucceeded = createAction(GET_USER_PROFILE_SUCCEEDED)

export const createUserInbox = createAction(CREATE_USER_INBOX)
export const createUserInboxFailed = createAction(CREATE_USER_INBOX_FAILED)
export const createUserInboxSucceeded = createAction(CREATE_USER_INBOX_SUCCEEDED)

export const verifyAccountEmail = createAction(VERIFY_ACCOUNT_EMAIL)
export const verifyAccountEmailFailed = createAction(VERIFY_ACCOUNT_EMAIL_FAILED)
export const verifyAccountEmailSucceeded = createAction(VERIFY_ACCOUNT_EMAIL_SUCCEEDED)

export const registerUserByOauth2 = createAction(REGISTER_USER_BY_OAUTH2)
export const registerUserByOauth2Failed = createAction(REGISTER_USER_BY_OAUTH2_FAILED)
export const registerUserByOauth2Succeeded = createAction(REGISTER_USER_BY_OAUTH2_SUCCEEDED)

export const resendAccountVerificationEmail = createAction(RESEND_ACCOUNT_VERIFICATION_EMAIL)
export const resendAccountVerificationEmailFailed = createAction(
  RESEND_ACCOUNT_VERIFICATION_EMAIL_FAILED,
)
export const resendAccountVerificationEmailSucceeded = createAction(
  RESEND_ACCOUNT_VERIFICATION_EMAIL_SUCCEEDED,
)

export const showRegistrationError = createAction(SHOW_REGISTRATION_ERROR)
export const clearRegisterUserError = createAction(CLEAR_REGISTER_USER_ERROR)
